'use client';

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import s from './SupportFormModal.module.scss';
import Richtext from '../Richtext/Richtext';
import FormInputField from '../FormInputField/FormInputField';
import FormTextAreaField from '../FormTextAreaField/FormTextAreaField';
import classNames from 'classnames';
import Icon from '../Icon/Icon';
import { t } from '../../i18n';
import { useForm } from 'react-hook-form';

const SupportFormModal = ({ content, contentThankYou }) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const [showSuccess, setShowSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = (values) => {
        setIsLoading(true);

        setTimeout(() => {
            setIsLoading(false);
            setShowSuccess(true);
        }, 1000);

        const data = {
            form: values,
        };
    };

    const buttonClasses = classNames(s.SubmitButton, {
        [s[`SubmitButton--Submitted`]]: showSuccess,
    });

    return (
        <div className={s.Root}>
            <form className={s.Form} onSubmit={handleSubmit(onSubmit)}>
                <div className={s.Content}>
                    {showSuccess && (
                        <div className={s.RichText}>
                            <Richtext text={contentThankYou} />
                        </div>
                    )}
                    {!showSuccess && (
                        <>
                            <div className={s.RichText}>
                                <Richtext text={content} />
                            </div>
                            <div className={s.Form}>
                                <div
                                    className={classNames(
                                        s.Row,
                                        s['Row--Half']
                                    )}>
                                    <div className={s.Field}>
                                        <FormInputField
                                            label="Name"
                                            type="text"
                                            name="name"
                                            errors={errors}
                                            register={{
                                                ...register('name', {
                                                    required: true,
                                                }),
                                            }}
                                        />
                                    </div>
                                    <div className={s.Field}>
                                        <FormInputField
                                            label="E-mail address"
                                            type="email"
                                            name="email"
                                            errorMessage="Please enter a valid email address"
                                            errors={errors}
                                            register={{
                                                ...register('email', {
                                                    required: true,
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className={s.Row}>
                                    <div className={s.Field}>
                                        <FormTextAreaField
                                            placeholder="Type here "
                                            label="Describe your situation"
                                            name="description"
                                            errors={errors}
                                            register={{
                                                ...register('description', {
                                                    required: true,
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
                <button className={buttonClasses} type="submit">
                    {showSuccess && (
                        <Icon name="CheckGreenCircle" className={s.Icon} />
                    )}
                    {isLoading && (
                        <div className={s.Spinner}>
                            <span className="sr-only">Loading...</span>
                        </div>
                    )}
                    <span>
                        {showSuccess
                            ? t('supportForm.inquirySent')
                            : t('supportForm.sendInquiry')}
                    </span>
                </button>
            </form>
        </div>
    );
};

SupportFormModal.propTypes = {};

export default SupportFormModal;
